



















import { defineComponent, reactive } from '@vue/composition-api'
import Layout from '@/components/organisms/common/Layout.vue'
import SearchInput from '@/components/organisms/questionnaire/SearchInput.vue'
import QuestionnaireTable from '@/components/organisms/questionnaire/QuestionnairesTable.vue'
import useVuex from '@/utils/useVuex'
import { QuestionnaireState, UserState } from '@/types/store'
import { UserRole } from '@/types/user'
import { GetQuestionnaireQuery } from '@/types/questionnaire'
import { getPreviewUrl } from '@/api/questionnaire'

export default defineComponent({
  name: 'AutomaticQuestionnaire',
  components: { Layout, SearchInput, QuestionnaireTable },
  setup(props, context) {
    const store = context.root.$store
    const state = reactive({
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
      questionnaires: useVuex<QuestionnaireState['questionnaires']>(
        context,
        () => store.getters['questionnaire/questionnaires'],
      ),
      completions: useVuex<QuestionnaireState['completeQuestionnaires']>(
        context,
        () => store.getters['questionnaire/completions'],
      ),
      isQuestionnaireLoading: useVuex<
        QuestionnaireState['isQuestionnaireLoading']
      >(context, () => store.getters['questionnaire/isQuestionnaireLoading']),
    })

    const search = (query: GetQuestionnaireQuery) => {
      store.dispatch('questionnaire/getAutomaticQuestionnaires', query)
    }

    const preview = async (id: number) => {
      window.open(await getPreviewUrl(id), '_blank')
    }

    return { state, UserRole, search, preview }
  },
})
